// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"src_views_Bridge_Jitsi_vue":"ab6a4adf","src_views_Bridge_index_vue":"26305ad8","src_views_Layout_vue":"18d8427c"}[chunkId] + ".js";
};